import { analyzeStatementXmlSegments } from "../../components/statement-nodes/parse";

export type Printer = {
  id: string;
  display_name: string;
  queue_name?: string;
  status: string;
  last_seen_at?: string;
  created_at: string;
};

// The API's status can remain "online" after a polling agent stops. A recent
// heartbeat is required before describing the destination as ready.
export function printerIsOnline(printer: Printer, now = Date.now()): boolean {
  if (printer.status.toLowerCase() !== "online" || !printer.last_seen_at)
    return false;
  const stamp = new Date(
    /(?:Z|[+-]\d\d:\d\d)$/.test(printer.last_seen_at)
      ? printer.last_seen_at
      : `${printer.last_seen_at}Z`,
  ).getTime();
  return (
    Number.isFinite(stamp) && now - stamp < 120_000 && stamp <= now + 10_000
  );
}

export function usableLabelText(text?: string): boolean {
  if (!text?.trim()) return false;
  const parsed = analyzeStatementXmlSegments(text);
  if (
    (text.trimStart().startsWith("<") ||
      /<(?:StatementNode|GlossaryStatementNode)\b/i.test(text)) &&
    !parsed.hasNodes
  )
    return false;
  return (
    !!parsed.plainText.trim() &&
    !parsed.hasMissingGlossaryFields &&
    !parsed.segments.some(
      (segment) =>
        segment.kind === "node" &&
        ["unresolved", "ambiguous"].includes(
          segment.node.attributes.matchStatus || "",
        ),
    )
  );
}
